<template>
  <v-app id="inspire">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <div class="login-body" v-show="isComponentLoaded">
      <v-card class="elevation-12" width="300">
        <v-toolbar color="bluePcm" dark flat>
          <v-toolbar-title>PCM Soluções</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-row no-gutters>
              <v-text-field
                v-model="form.agente"
                label="Número do Operador"
                name="login"
                append-outer-icon="mdi-account"
                type="number"
                :error-messages="agenteErrors"
                @input="$v.form.agente.$touch()"
                @blur="$v.form.agente.$touch()"
              />
            </v-row>
            <v-row no-gutters>
              <v-text-field
                v-model="form.ramal"
                label="Número do Ramal"
                name="phoneNumber"
                append-outer-icon="mdi-phone"
                type="number"
                :error-messages="ramalErrors"
                @input="$v.form.ramal.$touch()"
                @blur="$v.form.ramal.$touch()"
              />
            </v-row>
            <v-row no-gutters>
              <v-text-field
                v-model="form.password"
                id="password"
                label="Senha"
                name="password"
                @keyup.enter="login"
                :type="show ? 'text' : 'password'"
                :append-outer-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :error-messages="passwordErrors"
                @click:append-outer="show = !show"
                @input="$v.form.password.$touch()"
                @blur="$v.form.password.$touch()"
              />
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="bluePcm" dark @click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
      <Footer />
    </div>
  </v-app>
</template>

<script>
import Snackbar from '@/componentes/Snackbar'
import Footer from '@/componentes/Footer'
import searchPermissionServices from '@/utils/commomServices/searchPermissionServices'
import registerUserService from '@/utils/commomServices/registerUserService'
import { ioInstance } from "@/main";

import loginOperadorHttpService from '../_services/loginOperadorHttpService'
import { validateData, validateComputed } from '../_validations'

export default {
  name: 'LoginOperador',
  components: { Snackbar, Footer },
  data: () => ({
    form: {
      agente: '',
      action: 'login',
      ramal: '',
      password: '',
      realizouEvento: 'Operador',
    },
    show: false,
    snackbar: false,
    text: '',
    isComponentLoaded: false,
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
  },

  async created() {
    const tokenOperador = localStorage.getItem('pcm_access_token_operador')
    const operadorLogado = localStorage.getItem('operador_logado')

    if (tokenOperador && operadorLogado) {
      try {
        const response = await searchPermissionServices.getMe(tokenOperador)

        const permissionNames = response.data.permissions.map(permission => permission.name)
        if (permissionNames.includes(process.env.VUE_APP_CALLCENTER_OPERADOR)) {
          const responseVerificaLogin = await loginOperadorHttpService.verificaLogin(operadorLogado)
          if (typeof responseVerificaLogin.data !== 'string') {
            this.$router.push({ name: 'operator-screen' })
          } else {
            this.isComponentLoaded = true
          }
        }
      } catch (err) {
        console.log(err)
        this.isComponentLoaded = true
      }
    } else {
      this.isComponentLoaded = true
    }
  },

  methods: {
    async login() {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }

      try {
        const response = await registerUserService.postUser({ login: this.form.agente, password: this.form.password })
        const responsePermissions = await searchPermissionServices.getMe(response.data.access_token)

        const permissionNames = responsePermissions.data.permissions.map(permission => permission.name)
        if (!permissionNames.includes(process.env.VUE_APP_CALLCENTER_OPERADOR)) {
          const confirmOperador = window.confirm('Este login não pertence a um operador. Deseja logar-se como usuário?')

          if (confirmOperador) {
            this.$router.push({ name: 'login' })
          }
        } else {
          localStorage.pcm_access_token_operador = response.data.access_token
          localStorage.operador_logado = this.form.agente

          await registerUserService.loginOperador(this.form)
          ioInstance.emit("refreshInfo");

          this.$router.push({ name: 'operator-screen' })
        }
      } catch (err) {
      
        if (err.response.data[0] && err.response.data[0].msg.response === 'agente esta logado') {
         
          if (err.response.data[0].msg.ramal === this.form.ramal) {
            localStorage.operador_logado = this.form.agente
            this.$router.push({ name: 'operator-screen' })
          } else {
            this.text = `Operador está logado no ramal ${err.response.data[0].msg.ramal}`
            this.snackbar = true
          }
        }else if(err.response.data[0]){
            console.log("ENTROU AQUI",err.response.data[0])
            this.text = err.response.data[0].msg.response
          this.snackbar = true
        } 
        else {
          this.text = "Operador ou senha Incorretos"
          this.snackbar = true
          return
        }

      }
    },
  },
}
</script>

<style scoped>
.login-body {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--v-background-base);
}

.footer {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
